import Masonry from 'masonry-layout';

const imagesGrid = document.querySelector('.images-grid');
const GalleryGrid = document.querySelector('.gallery-grid');
const brandsGrid = document.querySelector('.brands-grid');
const cardsGrid = document.querySelector('.cards-grid');
const tentsGrid = document.querySelector('.tents-grid');
const tentsGrid2 = document.querySelector('.tents-grid-2');

if (imagesGrid) {

    var msnry = new Masonry('.images-grid', {
        itemSelector: '.grid-item',
        percentPosition: true,
    });

}

if (GalleryGrid) {

    var msnry = new Masonry('.gallery-grid', {
        itemSelector: '.grid-item',
        percentPosition: true,
    });

}

if (brandsGrid) {

    var msnry = new Masonry('.brands-grid', {
        itemSelector: '.grid-item',
        percentPosition: true,
    });

}

if (cardsGrid) {

    var msnry = new Masonry('.cards-grid', {
        itemSelector: '.grid-item',
        percentPosition: true,
    });

}

if (tentsGrid) {

    var msnry = new Masonry('.tents-grid', {
        itemSelector: '.grid-item',
        percentPosition: true,
    });
    
}

if (tentsGrid2) {

    var msnry = new Masonry('.tents-grid-2', {
        itemSelector: '.grid-item',
        percentPosition: true,
    });

}
